import { createContext } from 'react';
import type { useCurrentUser, useCurrentUserNotifications } from '../hooks/auth';

export type SessionContextType = Partial<ReturnType<typeof useCurrentUser>> & {
  sessionExists?: boolean;
  setSessionExists: () => void; // No longer takes a boolean parameter
  notifications?: ReturnType<typeof useCurrentUserNotifications>;
  logout?: () => void;
};

export const SessionContext = createContext<SessionContextType>({
  sessionExists: false,
  setSessionExists: () => {},
  logout: async () => {},
});
